import { Configuration, PopupRequest } from "@azure/msal-browser";

// MSAL Configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || "your-client-id-here", // Replace with your Azure AD app registration client ID
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID || "your-tenant-id-here"}`, // Replace with your tenant ID
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000", // Must match redirect URI in Azure AD app registration
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set to "true" if you are having issues on IE11 or Edge
    secureCookies: false, // Set to true for production with HTTPS
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // LogLevel.Error
            console.error(message);
            return;
          case 1: // LogLevel.Warning
            console.warn(message);
            return;
          case 2: // LogLevel.Info
            // console.info(message);
            return;
          case 3: // LogLevel.Verbose
            console.debug(message);
            return;
        }
      }
    }
  },
};

// Scopes for ID token - includes profile and email to get user info and roles
export const loginRequest: PopupRequest = {
  scopes: ["openid", "profile", "email"],
  // Removed prompt: "select_account" to avoid unnecessary prompts on refresh
};

// Scopes for API calls - you may need to adjust these based on your backend API requirements
export const apiRequest = {
  scopes: ["openid", "profile", "email"],
};

// User roles: employee/admin/founder come from Entra JWT; red_team/infra_admin from app RBAC
export const USER_ROLES = {
  EMPLOYEE: "employee",
  ADMIN: "admin",
  FOUNDER: "founder",
  RED_TEAM: "red_team",
  INFRA_ADMIN: "infra_admin",
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

/** App RBAC role keys (MySQL), not present in Entra JWT */
export const APP_ROLE_KEYS = [
  USER_ROLES.RED_TEAM,
  USER_ROLES.INFRA_ADMIN,
] as const;

export type AppRoleKey = typeof APP_ROLE_KEYS[number];

export const isAppRoleKey = (role: string): role is AppRoleKey =>
  (APP_ROLE_KEYS as readonly string[]).includes(role);

// Role GUID mappings from environment variables (Entra coarse roles only)
export const ROLE_MAPPINGS = {
  [process.env.REACT_APP_EMPLOYEE_ROLE_ID || '']: USER_ROLES.EMPLOYEE,
  [process.env.REACT_APP_ADMIN_ROLE_ID || '']: USER_ROLES.ADMIN,
  [process.env.REACT_APP_FOUNDER_ROLE_ID || '']: USER_ROLES.FOUNDER,
};

// Helper function to get role name from GUID
export const getRoleFromGuid = (roleGuid: string): UserRole | null => {
  return ROLE_MAPPINGS[roleGuid] || null;
};

// Helper function to get all configured role GUIDs
export const getConfiguredRoleGuids = (): string[] => {
  return Object.keys(ROLE_MAPPINGS).filter(guid => guid !== '');
};
